<template>
  <v-app style="display: flex; background-color: #F7F7F7; ">
    
    <TopBar 
      v-if="isLoggedIn && showMainBars"
      @logout="logOut"
    />
    
    <div :style="'width: ' + screenWidth + ' !important;'">
      
      <Sidebar 
        v-if="isLoggedIn"
        v-model="drawer" 
        :mini-value.sync="mini"
        @open-chat="showChatModal = true"
        @logout="logOut"
      />
      
      <RightSidebar
        v-if="isLoggedIn && showMainBars"
        :isOpen="isRightSidebarOpen"
        @update:isOpen="isRightSidebarOpen = $event"
        :isMobile="isMobile"
        :isSidebarMini="isRightSidebarMini"
        :title="rightSidebarTitle"
        :show-search="showRightSidebarSearch"
        :show-actions="showRightSidebarActions"
        :show-sectors="true"
        @toggle="toggleRightSidebar"
        @select-item="handleRightSidebarItemSelect"
        @item-action="handleRightSidebarItemAction"
        @add-item="handleRightSidebarAddItem"
        @sectors-loaded="handleSectorsLoaded"
        @sectors-error="handleSectorsError"
      />
      
      <v-main :style="mainStyle">
        <SnackBar v-bind="{ ...optionsSnackBar }" />
        <DialogAlert v-bind="{ ...optionsDialogAlert }" />
        <DatePickerDialog v-bind="{ ...paramDialogDate }" />
        <router-view />
      </v-main>
    </div>
    <!-- Modal de Chat fixo no canto inferior direito -->
     
    <v-dialog
      v-model="showChatModal"
      persistent
      no-click-animation
      max-width="640px"
      transition="dialog-bottom-transition"
      hide-overlay
      content-class="chat-dialog-content"
      style="z-index: 1000"
    >
      <v-card
        flat
        tile
        class="pa-0 elevation-0 custom-chat-card"
        style="width: 640px; height: 90vh; min-height: 640px;"
      >
        <!-- Corpo do Chat com um iframe ou webview apontando para seu assistente -->
        <div style="flex: 1; height: 100%;">
          <div class="close-button-container">
            <v-btn 
              icon 
              color="white"
              @click="showChatModal = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <iframe
            id="chatFrame"
            :src="agentChatURL"
            width="100%"
            height="100%"
            frameborder="0"
            allow="microphone; camera; autoplay"
          ></iframe>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>


<script>
import store from "@/store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import SnackBar from "@/components/SnackBar/SnackBar";
import DialogAlert from "@/components/DialogAlert/DialogAlert";
import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog";
import Sidebar from "@/components/Sidebar/Sidebar";
import TopBar from "@/components/TopBar/TopBar";
import RightSidebar from "@/components/RightSidebar/RightSidebar";
import { isMigratedFeature } from "@/router/migratedFeatures.js";

export default {
  name: "App",
  components: {
    SnackBar,
    DialogAlert,
    DatePickerDialog,
    Sidebar,
    TopBar,
    RightSidebar
  },
  data: () => ({
    agentChatURL: "https://foz-agent-465458998613.us-central1.run.app",
    drawer: true,
    mini: true,
    group: [],
    teste: store.state.loggedIn,
    showChatModal: false,
    rightSidebarTitle: "Unidades",
    showRightSidebarSearch: true,
    showRightSidebarActions: false,
    //hide sidebar
    isRightSidebarMini: false,
    rightSidebarWidth: 336,
    isRightSidebarOpen: true,
  }),
  computed: {
    ...mapGetters([
      "optionsSnackBar",
      "isLoggedIn",
      "paramDialogDate",
      "getCurrentUser",
      "optionsDialogAlert",
      "getCurrentUserData",
      "getCurrentUserRank",
      "getCurrentUserName",
    ]),
    isMobile() {
      console.log('ismobile APP')
      return this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm'
    },
    isTablet() {
      return this.$vuetify.breakpoint.name == "md";
    },
    isPC() {
      return (
        this.$vuetify.breakpoint.name == "lg" ||
        this.$vuetify.breakpoint.name == "xl"
      );
    },
    screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    showMainBars() {
      // Rota migrada renderiza só o aviso — sem TopBar nem RightSidebar em volta.
      if (isMigratedFeature(this.$route && this.$route.meta && this.$route.meta.feature)) return false;

      return this.$route && (this.$route.path === '/dashboard' || this.$route.path === '/consumption' || this.$route.path === '/consumption-by-tariff' || 
        this.$route.path === '/alertas' || this.$route.path === "/reservoir" || this.$route.path === "/goals-forecasts");

    },
    mainStyle() {
      /*let style = {};
      if (this.showMainBars) {
        style.paddingTop = this.isMobile ? '48px' : '64px';
        style.paddingRight = this.isMobile ? '260px' : '300px';
      } else {
        style.paddingTop = '0px';
        style.paddingRight = '0px';
      }
      return style;
    },*/
    // Mobile: sidebar não empurra layout
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        marginRight: '0px',
        transition: 'margin-right 0.3s ease'
      }
    }

    // Desktop
    const width = this.isRightSidebarOpen
      ? this.rightSidebarWidth
      : 0

    return {
      marginRight: this.isLoggedIn && this.showMainBars
        ? `${width}px`
        : '0px',
      transition: 'margin-right 0.3s ease'
      }
    }
  },
  methods: {
    ...mapActions([
      "logout",
      "checkUserStatus",
    ]),
    ...mapMutations(["CLEAR_STATE"]),

    handleButtonMenu() {
      this.mini = !this.mini
    },
    logOut() {
      localStorage.clear();
      this.showChatModal = false;
      this.logout();
      this.$router.push("/");
    },
    toggleRightSidebar() {
      this.isRightSidebarOpen = !this.isRightSidebarOpen;
    },
    handleRightSidebarItemSelect(item) {
      // this.selectedRightSidebarItem = item.id;
      // console.log('Unidade selecionada:', item);
      
      // // Navegar para a página de unidades com a unidade selecionada
      // this.$router.push({
      //   path: '/units',
      //   query: { selectedUnit: item.id }
      // });
    },
    handleRightSidebarItemAction({ action, item }) {
      console.log('Ação executada:', action.label, 'na unidade:', item.title);
      
      // Exemplo de implementação das ações
      switch (action.label) {
        case 'Visualizar':
          // Navegar para visualizar a unidade
          this.$router.push({
            path: '/units',
            query: { selectedUnit: item.id, action: 'view' }
          });
          break;
        case 'Editar':
          // Navegar para editar a unidade
          this.$router.push({
            path: '/units',
            query: { selectedUnit: item.id, action: 'edit' }
          });
          break;
        default:
          console.log('Ação não implementada:', action.label);
      }
    },
    handleRightSidebarAddItem() {
      console.log('Adicionando novo item');
      // Implementar lógica para adicionar novo item
      // Por exemplo, abrir um modal de criação
    },
    handleSectorsLoaded({ unitId, sectors }) {
      //console.log(`Setores carregados para unidade ${unitId}:`, sectors);
      // Aqui você pode implementar lógica adicional quando os setores são carregados
      // Por exemplo, atualizar o estado global, mostrar notificações, etc.
    },
    handleSectorsError({ unitId, error }) {
      console.error(`Erro ao carregar setores da unidade ${unitId}:`, error);
      // Aqui você pode implementar tratamento de erro
      // Por exemplo, mostrar uma notificação de erro para o usuário
    },
  },
  async mounted() {
    // Verifica o status do usuário quando a aplicação carrega
    if (this.isLoggedIn) {
      await this.checkUserStatus();
    }

    this.$watch('showChatModal', (val) => {
      if (val) {
        this.$nextTick(() => {
          const chatFrame = document.getElementById('chatFrame');
          if (chatFrame) {
            const userData = { userId: this.getCurrentUser.uid };
            chatFrame.onload = () => {
              chatFrame.contentWindow.postMessage(userData, this.agentChatURL);
            };
          } else {
            console.error("Elemento chatFrame não encontrado.");
          }
        });
      }
    });
  },
};
</script>


<style scoped>
#bg {
  position: fixed;
  right: 0;
  bottom: 0;
  top: 45px;
  min-width: 100%;
  min-height: 100%;
}

#bg-mobile {
  position: fixed;
  left: 0;
  top: -290px;
}

#bg-tablet {
  position: fixed;
  right: 0;
  bottom: 0;
  top: -190px;
  min-width: 100%;
  min-height: 100%;
}

.title-displays {
  font-size: 25px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-weight: bold;
}
::v-deep .chat-dialog-content {
  position: fixed !important;
  bottom: 16px;
  right: 16px;
  margin: 0 !important;
  border-radius: 20px 20px 0px 20px!important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 2000;
}
::v-deep .custom-chat-card {
  background: transparent !important;
  border-radius: 20px !important; /* reforça o arredondado */
  overflow: hidden !important;    /* garante que as bordas serão "cortadas" */
}

.close-button-container {
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
}

</style>
